import React, { ReactNode } from "react";
import { Row, Col, Skeleton, Space, Typography } from "antd";

const { Text } = Typography;

interface SummaryReportSkeletonProps {
  rowCount: number;
  colCount: number;
  children:ReactNode;
  isLoading:boolean
}

const SummaryReportSkeleton: React.FC<SummaryReportSkeletonProps> = ({ rowCount, colCount,children,isLoading }) => {
  return (
    <>
    {
        isLoading?<>
        
    <Row gutter={[20, 20]}>
      {Array.from({ length: rowCount * colCount }).map((_, index) => (
        <Col key={index} xs={24} lg={8}>
          <Row className="!bg-white shadow-lg p-4 rounded-md !h-[140px] !flex items-center">
            <Col xs={24} lg={18}>
              <div>
                <Text className="!text-[#6E7583]"><Skeleton active paragraph={{ rows: 1 }} /></Text>
              </div>
              <div>
                <Space>
                  <Text className="!text-2xl !font-bold">
                    <Skeleton.Input active style={{ width: 50 }} />
                  </Text>
                  <Skeleton.Input active style={{ width: 20 }} />
                </Space>
              </div>
            </Col>
            <Col xs={24} lg={6} className="!flex justify-end items-center">
              <Skeleton.Avatar active size={40} shape="circle" />
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
        
        </>:<>
        {children}
        </>
    }
    </>
  );
};

export default SummaryReportSkeleton;
